import { render, staticRenderFns } from "./PerformanceData.vue?vue&type=template&id=3f43859c&scoped=true&"
import script from "./PerformanceData.vue?vue&type=script&lang=js&"
export * from "./PerformanceData.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceData.vue?vue&type=style&index=0&id=3f43859c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f43859c",
  null
  
)

export default component.exports